import Interface from "../Interface";
var jalaali = require('jalaali-js');

class     PersianDate {

    gregorian_to_jalali(gy, gm, gd) {
        var g_d_m, jy, jm, jd, gy2, days;
        g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        gy2 = (gm > 2) ? (gy + 1) : gy;
        days = 355666 + (365 * gy) + ~~((gy2 + 3) / 4) - ~~((gy2 + 99) / 100) + ~~((gy2 + 399) / 400) + gd + g_d_m[gm - 1];
        jy = -1595 + (33 * ~~(days / 12053));
        days %= 12053;
        jy += 4 * ~~(days / 1461);
        days %= 1461;
        if (days > 365) {
            jy += ~~((days - 1) / 365);
            days = (days - 1) % 365;
        }
        if (days < 186) {
            jm = 1 + ~~(days / 31);
            jd = 1 + (days % 31);
        } else {
            jm = 7 + ~~((days - 186) / 30);
            jd = 1 + ((days - 186) % 30);
        }
        return [jy, jm, jd];
    }

    jalali_to_gregorian(jy, jm, jd) {
        var sal_a, gy, gm, gd, days;
        jy += 1595;
        days = -355668 + (365 * jy) + (~~(jy / 33) * 8) + ~~(((jy % 33) + 3) / 4) + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
        gy = 400 * ~~(days / 146097);
        days %= 146097;
        if (days > 36524) {
            gy += 100 * ~~(--days / 36524);
            days %= 36524;
            if (days >= 365) days++;
        }
        gy += 4 * ~~(days / 1461);
        days %= 1461;
        if (days > 365) {
            gy += ~~((days - 1) / 365);
            days = (days - 1) % 365;
        }
        gd = days + 1;
        sal_a = [0, 31, ((gy % 4 === 0 && gy % 100 !== 0) || (gy % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        for (gm = 0; gm < 13 && gd > sal_a[gm]; gm++) gd -= sal_a[gm];
        return [gy, gm, gd];
    }

    getCurrent(){
        let currentDate = new Date();
        let  jd=jalaali.toJalaali(currentDate);
        if(jd){
            let s=jd.jy+"/"+jd.jm+"/"+jd.jd;
            return s;
        }
        return  false;
    }

    check(date) {
        let res = false;
        if(!Interface.isEmptyString(date)) {
            let dateArray = date.split('/');
            if (dateArray.length === 3) {
                let y = parseInt(dateArray[0]);
                if (y >= 1000) {
                    let m = parseInt(dateArray[1]);
                    if (m >= 1 && m <= 12) {
                        let d = parseInt(dateArray[2]);
                        if (d >= 1 && d <= 31) {
                            res = true;
                        }
                    }
                }
            }
        }
        return res;
    };

    isLeapYear(year) {
        return (((((year - 474) % 2820) + 512) * 682) % 2816) < 682;
    };

    getDays(date) {
        var dateArray = date.split('/');
        let m=parseInt(dateArray[1],10);
        let d=parseInt(dateArray[2],10);
        if (m < 8)
            return (m - 1) * 31 + d  ;
        return 6 * 31 + (m - 7) * 30 + d ;
    };

    getWeekDay(date) {
        return Interface.mod(this.getDiffDays('1392/03/25', date), 7);
    };

    getDiffDays(date1, date2) {
        var diffDays = this.getDays(date2) - this.getDays(date1);
        var dateArray1 = date1.split('/');
        var dateArray2 = date2.split('/');

        let yr1=parseInt(dateArray1[0],10);
        let yr2=parseInt(dateArray2[0],10);

        var y1 = (yr1 < yr2) ? yr1 : yr2;
        var y2 = (yr1 < yr2) ? yr2 : yr1;
        for (var y = y1; y < y2; y++)
            if (this.isLeapYear(y))
                diffDays += (yr1 < yr2) ? 366 : -366;
            else
                diffDays += (yr1 < yr2) ? 365 : -365;
        return parseInt(diffDays,10);
    };

    getMonthDays(date) {
        var dateArray = date.split('/');
        let m=parseInt(dateArray[1],10);
        if (m < 7)
            return 31;
        if (m < 12)
            return 30;
        return this.isLeapYear(dateArray[0]) ? 30 : 29;
    };

    nextYear(date, num = 1) {
        var dateArray = date.split('/');
        return (parseInt(dateArray[0],10) + num).toString() + "/" + dateArray[1] + "/" + dateArray[2];
    };

    previousYear(date, num = 1) {
        var dateArray = date.split('/');
        return (parseInt(dateArray[0],10) - num).toString() + "/" + dateArray[1] + "/" + dateArray[2];
    };

    nextMonth(date) {
        var dateArray = date.split('/');
        let m=parseInt(dateArray[1],10);
        if (m < 9)
            return dateArray[0] + "/0" + (m + 1).toString() + "/" + dateArray[2];
        if (m === 9)
            return dateArray[0] + "/10/" + dateArray[2];
        if (m < 12)
            return dateArray[0] + "/" + (m + 1).toString() + "/" + dateArray[2];
        return (parseInt(dateArray[0],10) + 1).toString() + "/01/" + dateArray[2];
    };

    previousMonth(date) {
        var dateArray = date.split('/');
        let m=parseInt(dateArray[1],10);
        if (m > 10)
            return dateArray[0] + "/" + (m - 1).toString() + "/" + dateArray[2];
        if (dateArray[1] > 1)
            return dateArray[0] + "/0" + (m - 1).toString() + "/" + dateArray[2];
        return (parseInt(dateArray[0],10) - 1).toString() + "/12/" + dateArray[2];
    };

}

export default PersianDate;
